export default __webpack_public_path__ + "static/media/jost-500-medium.21b6bad9.woff";